import React from 'react';

const EditPencil = ({ height = 48, width = 48, color = '#B3B3B3', pencilColor = '#52bcda' }) => (
  <svg className="svg-icon" height={height} width={width} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <title>n edit</title>
    <g>
      <path d="M22,34h-7c-0.55225,0-1-0.44727-1-1v-7c0-0.26562,0.10547-0.51953,0.29297-0.70703l22-22 c0.39062-0.39062,1.02344-0.39062,1.41406,0l7,7c0.39062,0.39062,0.39062,1.02344,0,1.41406l-22,22 C22.51953,33.89453,22.26514,34,22,34z" fill={pencilColor}/>
      <path d="M38,47H2c-0.55225,0-1-0.44727-1-1V10c0-0.55273,0.44775-1,1-1h16c0.55225,0,1,0.44727,1,1s-0.44775,1-1,1H3 v34h34V30c0-0.55273,0.44775-1,1-1s1,0.44727,1,1v16C39,46.55273,38.55225,47,38,47z" fill={color} />
    </g>
  </svg>
);

export default EditPencil;
